// The two remaining south-scene buildings. Raised detail stays inside their solid footprints.
import type {HdBuilding} from '../../common/src/data';
import type {LightFn} from './hd-registry';
import {type G,K,HT,px,frame,bands,disc,text} from './hd-kit';
import {panel,label,fan,pipe,window} from './hd-hachi-study';
export const EDGE_STUDY_BUILDINGS=['ks-flats-e','ks-office-e'] as const;
export function paintKabukiEdgeStudy(g:G,b:HdBuilding,x:number,y:number,L:LightFn){
 if(!(EDGE_STUDY_BUILDINGS as readonly string[]).includes(b.id))return;
 const w=b.w*HT,h=b.h*HT,rh=(b.h-b.face)*HT,fy=y+rh,flats=b.id==='ks-flats-e';
 g.save();g.beginPath();g.rect(x,y,w,h);g.clip();
 pipe(g,x+w-13,y+18,rh-33);
 if(flats){
  // A modest roof terrace, bounded by a low maintenance rail.
  panel(g,x+22,y+76,w-47,113,K.woodLo);
  for(let j=5;j<110;j+=9)px(g,x+25,y+76+j,w-53,1,K.woodHi);
  for(const yy of [y+77,y+180]){px(g,x+24,yy,w-51,2,K.metalHi);for(let j=28;j<w-30;j+=12)px(g,x+j,yy-7,2,10,K.metalLo);}
  panel(g,x+31,y+91,45,32,K.wallLo);window(g,x+37,y+97,33,19,K.glassLo);
  // Outdoor table, stools and planters read as rooftop furniture, not street obstacles.
  disc(g,x+111,y+131,19,10,K.woodHi);disc(g,x+111,y+130,17,8,K.wood);px(g,x+109,y+139,4,12,K.woodLo);
  for(const xx of [x+84,x+135]){disc(g,xx,y+144,7,4,K.metalHi);px(g,xx-3,y+148,2,8,K.metalLo);}
  for(const xx of [x+35,x+62,x+132]){panel(g,xx,y+162,20,13,K.woodLo);disc(g,xx+10,y+159,8,9,K.metalLo);px(g,xx+9,y+157,2,12,K.woodHi);}
  px(g,x+32,y+57,116,1,K.metalHi);for(let j=0;j<4;j++){px(g,x+40+j*27,y+57,2,5,K.woodHi);px(g,x+36+j*27,y+61,17,22,j%2?K.wallLo:K.concreteHi);}
  bands(g,x+2,fy+2,w-4,h-rh-4,K.concrete,K.wallLo,8);
  // This face meets the next building: residential windows and utilities, no new doorway.
  for(let j=0;j<3;j++){const wx=x+13+j*58;window(g,wx,fy+10,43,34,j===1?K.glassLo:K.amber);px(g,wx+4,fy+12,7,29,K.woodLo);px(g,wx+32,fy+12,7,29,K.woodLo);px(g,wx-2,fy+44,47,5,K.metalHi);for(let k=1;k<43;k+=9)px(g,wx+k,fy+34,2,13,K.metalLo);}
  pipe(g,x+11,fy+55,32);pipe(g,x+w-18,fy+53,35);
  for(let j=0;j<3;j++){panel(g,x+30+j*47,fy+61,31,22,K.metalLo);for(let k=4;k<19;k+=4)px(g,x+34+j*47,fy+61+k,23,1,K.metalHi);}
 }else{
  // Tall service core with a skylight and an organized fan bank.
  panel(g,x+24,y+67,71,92,K.concreteLo);px(g,x+27,y+69,65,3,K.concreteHi);
  panel(g,x+34,y+92,28,56,K.metalLo);for(let j=0;j<7;j++)px(g,x+37,y+98+j*6,22,1,K.metalHi);
  label(g,'UTIL',x+64,y+84,26,K.white);
  window(g,x+111,y+82,51,61,K.glassLo);for(let j=1;j<3;j++)px(g,x+113,y+82+j*20,47,2,K.metalHi);
  fan(g,x+28,y+176);fan(g,x+66,y+176);px(g,x+98,y+184,53,9,K.metalLo);px(g,x+101,y+185,47,2,K.metalHi);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.concrete,K.wallLo,8);
  for(let j=0;j<3;j++){window(g,x+13+j*58,fy+9,43,28,j===0?K.amber:K.glassLo);for(let k=7;k<24;k+=6)px(g,x+16+j*58,fy+9+k,37,1,K.metalLo);}
  px(g,x+7,fy+43,w-14,4,K.metalLo);label(g,'OFFICE',x+w/2-38,fy+41,76,K.white);
  window(g,x+w/2-22,fy+60,44,32,K.amber);px(g,x+w/2-1,fy+62,2,28,K.metalLo);
  for(const xx of [x+15,x+w-48]){panel(g,xx,fy+59,33,28,K.metalLo);text(g,'POST',xx+5,fy+64,K.white,1);px(g,xx+6,fy+78,21,2,K.ink);}
  L(x+w/2-18,fy+67,36,20,K.amber,.14,true);
 }
 frame(g,x+2,fy+2,w-4,h-rh-4,K.ink);px(g,x+2,y+h-4,w-4,3,K.ink);g.restore();
}
